<template>
  <div id="app">
    <router-view :confirm="handleConfirm" />

    <transition name="fade">
      <Loader v-if="isLoading" />
    </transition>

    <Confirm
      v-model="confirm.open"
      :onOk="confirm.onOk"
      :onCancel="confirm.onCancel"
      :title="confirm.title"
      :message="confirm.message"
      :type="confirm.type"
      :textButtonOk="confirm.textButtonOk"
      :textButtonCancel="confirm.textButtonCancel"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { connectSocket } from '@/configurations/webSocket';
import Loader from './components/Loader';
import Confirm from './components/Confirm';
import NavbarMixin from './components/Navbar/NavbarMixin';
import { removeToken } from './configurations/token';

export default {
  name: 'App',
  mixins: [NavbarMixin],
  components: {
    Loader,
    Confirm,
  },
  computed: {
    ...mapState('application', ['loading', 'menus']),
    ...mapState('subscription', ['subscription']),
    ...mapState('client', ['client']),

    isLoading() {
      return this.loading || this.loadingInit;
    },
  },
  data() {
    return {
      confirm: {
        title: '',
        message: '',
        type: 1,
        onOk: () => null,
        onCancel: () => null,
        open: false,
      },
    };
  },
  methods: {
    handleConfirm({ title, message = '', type, onOk, onCancel, textButtonOk, textButtonCancel }) {
      this.confirm = {
        title,
        message,
        type,
        onOk,
        onCancel,
        open: true,
        textButtonOk,
        textButtonCancel,
      };
    },
    changeTheme() {
      if (window.location.origin === process.env.VUE_APP_BASE_URL_360) {
        document.documentElement.setAttribute('data-theme', 'clipp360');
      }
    },
    async initStates() {
      this.changeTheme();
      try {
        await this.setClient();
        await this.setSubscription();

        const io = connectSocket();
        if (this.client?.id && io) {
          io.on('connect', () => {
            io.emit('join:client', {
              id: this.client.id,
              uuid: this.client.uuid,
              name: this.client.businessName || this.client.name,
              origin: 'Clipp360',
            });
          });
        }

        this.setIsPlan360(this.subscription.paymentMode.id);
        this.setUser();
        this.getMenus();
      } catch {
        this.loadingInit = false;
      }
    },
    ...mapActions('user', ['setUser']),
    ...mapActions('subscription', ['setSubscription', 'setIsPlan360']),
    ...mapActions('client', ['setClient']),
    ...mapActions('application', ['getMenus', 'setDefaultRoute']),
  },
  async created() {
    await this.initStates();
  },
  updated() {
    const routes = this.$route.fullPath.split('/').filter((route) => route);

    if (!this.$route.meta.public && this.menus.length === 0) {
      this.$http.interceptors.response.use(
        (response) => response,
        async (error) => {
          if (error.response.status === 401) {
            removeToken();
            window.location.href = '/#/login';
          }
          return Promise.reject(error);
        },
      );

      this.getMenus();
    }

    if (routes.length > 0) {
      const [menu, submenu] = routes;
      this.setDefaultRoute({
        menu,
        submenu,
      });
      this.setDocumentTitle(this.menus, this.$route);
    }
  },
};
</script>
